var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe.components/common/modal/modal.indra.service';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import * as fromStore from '@ibe/store/index';
import { select, Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
var INDRAAddExtraModalComponent = /** @class */ (function (_super) {
    __extends(INDRAAddExtraModalComponent, _super);
    function INDRAAddExtraModalComponent(store, modalService) {
        var _this = _super.call(this, modalService) || this;
        _this.store = store;
        _this.modalService = modalService;
        _this.flights$ = _this.store.pipe(select(fromStore.getSelectedBookedTripFlights));
        _this.title$ = _this.store.select(fromStore.getConfirmModalTitle);
        _this.extra_features = [];
        _this.isAlive = true;
        _this.TYPE = '';
        return _this;
    }
    INDRAAddExtraModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.data && this.data.length) {
            if (this.data[0].feature) {
                this.feature = this.data[0].feature;
            }
            if (this.data[0].flightDetails) {
                this.flightDetails = this.data[0].flightDetails;
            }
        }
        // this.feature =
        this.flights$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (flights) {
            if (flights) {
                _this.flight = flights;
            }
        });
    };
    INDRAAddExtraModalComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRAAddExtraModalComponent.prototype.closeModal = function () {
        this.modalService.close();
    };
    INDRAAddExtraModalComponent.prototype.cancel = function () {
        this.store.dispatch(new ConfirmModalActions.PutConfirm('cancel'));
        this.closeModal();
    };
    INDRAAddExtraModalComponent.prototype.confirm = function () {
        this.store.dispatch(new ConfirmModalActions.PutConfirm('ok'));
        this.closeModal();
    };
    INDRAAddExtraModalComponent.prototype.INDRA_getFeature = function (flight) {
        var featureSelected;
        for (var i in flight.ancillaries) {
            if (flight.ancillaries[i].id == this.feature) {
                featureSelected = flight.ancillaries[i];
                break;
            }
        }
        return featureSelected;
    };
    return INDRAAddExtraModalComponent;
}(AbstractModalContentComponent));
export { INDRAAddExtraModalComponent };
